import { setInstanceGetter } from '@wix/wix-vod-shared/common';

export const setInstance = (instance) => setInstanceGetter(() => instance);
